"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TestimonialsLayout = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TestimonialsLayout = ({
  data,
  debug,
  modulePosition,
  className
}) => {
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const carouselOptions = (0, _react.useMemo)(() => ({
    navigation: {
      position: 'inside',
      showArrows: !isMobile
    },
    autoplay: {
      enabled: true,
      interval: _constants.TESTIMONIAL_CAROUSEL_INTERVAL
    },
    slider: {
      loop: true
    }
  }), [isMobile]);
  if (!data?.collection || data.collection.length < 1) {
    return (0, _utils.getModulesContentError)({
      debug,
      modulePosition,
      layout: _constants.TESTIMONIAL_MODULE_NAME
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Carousel, {
    ...carouselOptions,
    id: _constants.TESTIMONIAL_CAROUSEL_ID,
    children: data.collection.map(({
      textCollection,
      title,
      image,
      author,
      showStarRating
    }) => {
      const imageUrl = isMobile ? image?.urlMobile ?? image?.url ?? '' : image?.url ?? '';
      const hasImage = Boolean(imageUrl);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CarouselSlide, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
          className: className,
          "data-testid": getTestId(_constants.TESTIMONIAL_CAROUSEL_SLIDE),
          children: [hasImage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Image, {
              "data-testid": getTestId(_constants.TESTIMONIAL_CAROUSEL_IMAGE),
              src: imageUrl
            })
          }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContentWrapper, {
            hasImage: hasImage,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ContentInner, {
              hasImage: hasImage,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Title, {
                "data-testid": getTestId(_constants.TESTIMONIAL_CAROUSEL_TITLE),
                children: title
              }), showStarRating ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StarRating, {
                "data-testid": getTestId(_constants.TESTIMONIAL_CAROUSEL_STARS),
                max: 5,
                value: 5
              }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Description, {
                "data-testid": getTestId(_constants.TESTIMONIAL_CAROUSEL_DESCRIPTION),
                variant: "subtitle1",
                children: textCollection?.[0]?.text
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NameAndCountry, {
                "data-testid": getTestId(_constants.TESTIMONIAL_CAROUSEL_AUTHOR),
                variant: "body1",
                children: author
              })]
            })
          })]
        })
      }, title);
    })
  });
};
exports.TestimonialsLayout = TestimonialsLayout;
